import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';

import { IsArrayPipe } from 'v2/modules/shared/pipes/is-array.pipe';
import { ObjectToArrayPipe } from 'v2/modules/shared/pipes/object-to-array.pipe';
import { trackByValue } from 'v2/modules/shared/util/track-by.util';

@Component({
  selector: 'lum-sales-order-pull-notifications',
  standalone: true,
  imports: [CommonModule, IsArrayPipe, ObjectToArrayPipe],
  templateUrl: './sales-order-pull-notifications.component.html',
  styleUrls: ['./sales-order-pull-notifications.component.scss'],
})
export class SalesOrderPullNotificationsComponent implements OnInit {
  trackByValue = trackByValue;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data :any,
    private dialogRef :MatDialogRef<SalesOrderPullNotificationsComponent>,
  ) {}

  ngOnInit() :void {}

  onClose() :void {
    this.dialogRef.close();
  }

  get notification() :any {
    // TODO: define types
    return this.data;
  }
}
